module.exports = __webpack_public_path__ + "img/the-illinois.b4790c28.png";